"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
export class TimerEngine {
  constructor(handler, speed, ...args) {
    this._off = false;
    this._speed = 0;
    this._timeTask = handler;
    this._speed = speed;
    this._args = args;
  }
  run() {
    return __async(this, null, function* () {
      yield this._timeTask.call(this._args);
      if (this._off) {
        return false;
      }
      setTimeout(() => __async(this, null, function* () {
        yield this.run();
      }), this._speed);
    });
  }
  stop() {
    return __async(this, null, function* () {
      this._off = true;
    });
  }
  start() {
    return __async(this, null, function* () {
      this._off = false;
      return this.run();
    });
  }
}
